export const commonColors = {
  purple600: '#4644B2',
  purple400: '#8C92EF',
  purple300: '#B6B6E6',
  purple200: '#CECEF2',
  purple100: '#E9E9F9',
  purple50: '#F3F3FC',
  orange: '#FF714C',
  backgroundBlue: '#EDF3FF',
  backgroundPurple: '#F3F3FC',
  darkGray: '#7A7A7A',
  lightGray: '#E4E4E4',
  white: '#FFFFFF',
  black: '#000000',
  error: '#FDEDED',
  errorText: '#5F2120'
};
